<template>
  <div class="inner-content">
    <div class="clearfix shop-top">
      <div class="m-g-20">
        <div class="s-info">
          <div class="f-n">{{shop.name}}</div>
          <div class="m-g-13">
            <span class="s-tab f-t text-center" v-for="la in shop.labelList">{{la}}</span>
          </div>
          <div class="m-g-46">
            <span class="f-a">商家地址：{{shop.address}}</span><br>
          </div>
          <div class="m-g-10">
            <span class="f-a s-p">商家电话：{{shop.telephone}}</span>
          </div>
          <div class="m-g-10">
            <span class="f-a s-p">商家微信：{{shop.weixin}}</span>
          </div>
          <div class="m-g-10">
            <span class="f-a s-p">商家微博：{{shop.weibo}}</span>
          </div>
        </div>
        <div class="img-s-div img-c-div" v-bind:style='{ backgroundImage:"url("+shop.coverImgUrl+")" }'>
        </div>
      </div>
    </div>
    <div class="clearfix m-g-60 m-b-60">
      <div class="clearfix s-news">
        <div class="banner-r b-c-1">
          <span class="h-60" style="font-size:18px; color: #252525">商家资讯</span>
        </div>
        <div class="m-g-20" v-for="p in poster_list" @click="goPosterDetail(p.uuid)">
          <div class="news-info">
            <div class="f-ar-t clamp">{{p.title}}</div>
            <div class="m-g-10 f-ar-c">
              <span class="clamp" v-if="p.type !== 4">{{p.content[0].text}}</span>
              <span class="clamp" v-if="p.type === 4">{{p.content.text}}</span>
            </div>
          </div>
          <div class="img-news-div mg-style" v-bind:style="{backgroundImage: 'url(' + p.cover + ')'}"></div>
          <div class="line2 m-g-20"></div>
        </div>
      </div>
      <div class="clearfix s-detail">
        <div v-sticky="{ zIndex: 12, stickyTop: 0 }">
          <div class="s-details-tab">
            <!--<span class="f-title b-h-60 detail-ban" v-for="l in link">{{l}}</span>-->
            <!--<a class="f-title h-60 detail-ban">商家简介</a>-->
            <!--<a class="f-title h-60 detail-ban">优惠信息</a>-->
            <span :class="{'active': activeDetailTag === 0}" @click="scrollTo('s-profile', 0)">商家简介</span><span
            :class="{'active': activeDetailTag === 1}" @click="scrollTo('s-discount', 1)">优惠信息</span><span
            :class="{'active': activeDetailTag === 2}" @click="scrollTo('s-cases', 2)">商家案例</span>
          </div>
        </div>
        <div class="s-profile p-t-40" id="s-profile">
          <div class="pro-t-1">
            <div class="title1">
              <span class="f-title">商家简介</span>
            </div>
            <div class="rectangle-3 m-g-20 f-a">
              <span class="l-h-30 text-prewarp">{{shop.brief}}</span>
            </div>
            <div class="img-pro-div m-g-30 img-c-div" v-bind:style='{ backgroundImage:"url("+shop.briefImgUrl+")" }'>
            </div>
          </div>
        </div>
        <div class="s-discount p-t-30" id="s-discount">
          <div class="pro-t-1">
            <div class="title1">
              <span class="f-title">优惠信息</span>
            </div>
            <div class="rectangle-3 m-g-20 f-a">
              <span class="l-h-30 text-prewarp">{{shop.promotionInfo?shop.promotionInfo:'暂无'}}</span>
            </div>
          </div>
        </div>
        <div class="s-cases p-t-30" id="s-cases">
          <div class="pro-t-1">
            <div class="title1">
              <span class="f-title">商家案例</span>
            </div>
            <div class="rectangle-3 m-g-30">
              <div class="c-2-1 m-b-md b-gray-1 hp-item-6" v-for="c in case_list" @click="goToCase(c.id)">
                {{/** use background for image */}}
                <div class="clearfix m-a img-c-div h-44" v-bind:style="{backgroundImage: 'url(' + c.coverImgUrl + ')'}">
                  <!--<div class="collect-heat text-center">-->
                    <!--<i class="fa fa-heart" />-->
                    <!--<span class="gray-1 text-small">{{c.favorNum}}</span>-->
                  <!--</div>-->
                </div>
                <!--<div class="m-a text-center b-gray-1 p-a h-p-item-c">-->
                  <!--<div class="text-price m-b-md">¥{{c.sellPrice/100}}</div>-->
                  <!--<div class="gray-1 text-small text-elli">-->
                    <!--{{c.title}}<br>{{c.description}}-->
                 <!--</div>-->
                <!--</div>-->
                <div class="m-a b-gray-1 p-a h-p-item-c">
                  <div class="m-b-15 text-elli"><span class="f-6"><span>{{shop.cityName ? shop.cityName : '北京'}}</span>｜{{c.title}}</span>
                    <span class="f-7" v-if="(shop&&shop.name) !== null && (shop&&shop.name) !==undefined">－{{shop&&shop.name}}</span>
                  </div>
                  <div class="gray-1 text-small">
                    <!--<div class="text-elli">{{c.title}}</div>-->
                    <div class="text-elli">{{c.description}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="for-more text-center m-g-25">
          <span class="f-m" @click="seeMoreCase()">查看更多</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import scrollToElement from 'scroll-to-element';
import miniToastr from 'mini-toastr';
import VueSticky from 'vue-sticky';
import service from '../service/apiHelper';

export default {
  name: 'ShopDeatil',
  created() {
    service.getShopInfo(this.$route.params.id).then((resp) => {
      this.shop = resp.data.shop;
      this.case_list = resp.data.case_list;
      this.poster_list = resp.data.poster_list;
      this.shop.labelList = JSON.parse(this.shop.labelList);
    }, () => {
      this.$router.replace({ name: 'Index' });
    });
  },
  data() {
    return {
      activeDetailTag: 0,
      shop: {
        name: '',
        address: '',
        telephone: '',
        labelList: '',
        coverImgUrl: '',
        brief: '',
        briefImgUrl: '',
        promotionInfo: '',
      },
      case_list: {
        coverImgUrl: '',
        favorNum: '',
        sellPrice: '',
        title: '',
        description: '',
      },
      poster_list: {},
      link: ['商家简介', '优惠信息', '商家案例'],
    };
  },
  methods: {
    scrollTo(el, index) {
      this.activeDetailTag = index;
      const options = {
        easing: 'linear',
        offset: -60,
      };
      scrollToElement(`#${el}`, options);
    },
    goPosterDetail(id) {
      window.open(`#/NewsDetail/${id}`);
    },
    goToCase(id) {
      window.open(`#/CaseDetail/${id}`);
    },
    seeMoreCase() {
      service.getShopCaseList(this.$route.params.id, this.case_list.length).then((resp) => {
        if (resp.data.case_list.length <= 0) {
          miniToastr.error(resp.msg, '没有更多了');
        } else {
          this.case_list = this.case_list.concat(resp.data.case_list);
        }
      }, () => {
        this.$router.replace({ name: 'Index' });
      });
    },
  },
  directives: {
    sticky: VueSticky,
  },
};
</script>
<style scoped>
  .shop-top {
    height: 260px;
    border: 1px solid #e1e1e1;
    margin-top: 60px;
  }
  .img-s-div {
    width: 26%;
    /*border: 1px solid #e1e1e1;*/
    margin: 0px 0px 20px 20px;
    height: 220px;
  }
  .img-c-div {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .s-info {
    width: 69%;
    float: right;
    height: 220px;
  }
  .s-tab {
    width: 66px;
    height: 23px;
    border-radius: 2px;
    border: 1px solid #f3f3f3;
    margin-right: 24px;
    padding: 3px 9px;
  }
  .f-n {
    font-size: 22px;
    color: #252525;
  }
  .f-t {
    font-size: 12px;
    color: #a9a9a9;
  }
  .f-ar-t {
    font-size: 14px;
    color: #414141;
    line-height: 20px;
  }
  .f-ar-c {
    font-size: 10px;
    line-height: 1.5;
    color: #787878;
  }
  .m-g-13 {
    margin-top: 13px;
  }
  .m-g-46 {
    margin-top: 46px;
  }
  .m-g-20 {
    margin-top: 20px;
  }
  .f-a {
    font-size: 14px;
    color: #787878;
  }
  .m-g-10 {
    margin-top: 10px;
  }

  .m-g-60 {
    margin-top: 60px;
  }

  .m-g-40 {
    margin-top: 40px;
  }

  .m-g-30 {
    margin-top: 30px;
  }

  .m-g-25 {
    margin-top: 25px;
  }

  .m-b-60 {
    margin-bottom: 60px;
  }

  .p-t-30 {
    padding-top: 30px;
  }

  .p-t-40 {
    padding-top: 40px;
  }

  .s-news {
    float: right;
    width: 22%;
    height: 100%;
    /*border: 1px solid #e1e1e1;*/
  }

  .s-detail {
    width: 75%;
    height: 100%;
    border: 1px solid #e1e1e1;
  }

  .banner-r {
    height: 60px;
    text-align: center;
    vertical-align: middle;
    border: solid 1px #e1e1e1;
  }

  .b-c-1 {
    background-color: #f6f6f6
  }

  .f-title {
    font-size: 18px;
    color: #252525;
    border-left: 4px solid #ba882a;
    padding-left: 15px;
  }

  .h-60 {
    line-height: 60px;
  }
  /*.rec-1 {*/
    /*border-bottom: solid 1px #e1e1e1;*/
  /*}*/

  .s-details-tab {
    height: 60px;
    line-height: 60px;
    background-color: #f6f6f6;
    border-bottom: solid 1px #e3e3e3;
    font-size: 18px;
  }
  .s-details-tab > span {
    display: inline-block;
    height: 100%;
    padding: 0 38px;
    border-right: 1px solid #e5e5e5;
    vertical-align: middle;
    cursor: pointer;
  }

  .s-details-tab > span.active {
    background: #fff;
    border-top: 4px solid #ba882a;
    height: auto;
  }

  /*.s-details-tab a {*/
    /*text-decoration: none;*/
  /*}*/

  /*.detail-ban {*/
    /*width: 150px;*/
    /*text-align: center;*/
    /*border-right: solid 1px #e1e1e1;*/
    /*padding: 21px 38px 19px 38px;*/
    /*cursor: pointer;*/
  /*}*/

  .rectangle-2 {
    width: 4px;
    height: 16px;
    background-color: #ba882a;
  }

  .pro-t-1 {
    margin-left: 50px;
  }
  .title1 {
    padding: 10px 0 10px 0;
    border-bottom: 1px dashed #c1c1c1;
  }
  .line1 {
    width: 94%;
    border-bottom: 1px #c1c1c1 dashed;
  }

  .rectangle-3 {
    width: 97%;
  }

  .l-h-30 {
    line-height: 30px;
  }

  .img-pro-div {
    height: 500px;
    width: 770px;
    border: solid 1px #e1e1e1;
  }

  .c-2-1 {
    width: calc(100% / 2 - 20px);
    margin-right: 15px;
    float: left;
    box-sizing: border-box;
  }

  .for-more {
    margin-left: 50px;
    margin-bottom: 40px;
    background-color: #e1e1e1;
    height: 50px;
    width: 88%;
    float: left;
    line-height: 50px;
  }

  .f-m {
    font-size: 14px;
    color: #525252;
  }

  .f-m:hover {
    color: #ba882a;
  }

  .img-news-div {
    height: 80px;
    width: 42%;
    /*border: solid 1px #e1e1e1;*/
  }

  .mg-style{
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .news-info {
    float: right;
    width: 53%;
    height: 80px;
    vertical-align: middle;
  }

  .line2 {
    width: 100%;
    /*height: 1px;*/
    border-bottom: 1px #c1c1c1 dashed;
  }

  .clamp {
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .m-b-15 {
    /*margin-top: 10px;*/
    margin-bottom: 15px;
  }
  .f-6 {
    font-size: 16px;
    color: #525252;
    font-weight: bold;
  }
  .f-7{
    font-size: 16px;
    color: #787878;
    font-weight: lighter;
  }
</style>



// WEBPACK FOOTER //
// ShopDetail.vue?4f783213